const convertKelvinToCelsius = kelvin => {
  return parseInt((kelvin - 273.15), 10)

}

export default convertKelvinToCelsius



// WEBPACK FOOTER //
// ./src/utility/convertKelvinToCelsius.js